import React from 'react';
import cn from 'classnames';

import { withTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './Badge.module.scss';

const Badge = ({
  name,
  tag: tagFromProps,
  children,
  variant,
  disabled,
  isDarkMode,
  height,
  wrap,
  withIcon,
  invertedDark,
}) => (
  <div
    data-bem="Badge"
    data-tag={fromAnyToTrimmed(tagFromProps)}
    data-variant={String(variant)}
    className={cn({
      [CN.component]: true,
      [CN[`${variant}Variant`]]: variant,
      [CN.disabled]: disabled,
      [CN.wrap]: wrap,
      [CN.darkMode]: isDarkMode,
      [CN[`${height}Height`]]: height,
      [CN.withIcon]: withIcon,
      [CN.variantInvertDark]: invertedDark,
    })}
  >
    {name && <div>{name}</div>}
    {children}
  </div>
);

const BadgeHoc = withTheme({ hasBright: true })(Badge);

export default BadgeHoc;
